import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ModuleAccessControlService from "../../components/module-access-control/ModuleAccessControlService";

const initialState = {
	data: {},
	status: "idle",
};

export const fetchModuleAccessControl = createAsyncThunk("moduleAccessControl", async () => {
	const response = await ModuleAccessControlService.get();
	return response;
});

export const ModuleAccessControlSlice = createSlice({
	name: "moduleAccessControl",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchModuleAccessControl.pending, (state) => {
				state.status = "loading";
			})
			.addCase(fetchModuleAccessControl.fulfilled, (state, action) => {
				state.status = "idle";
				if (action.payload?.status === "OK") {
					state.data = JSON.parse(action.payload?.data);
				} else {
					state.data = [];
				}
			});
	},
});

export const selectModuleAccessControl = (state) => state.moduleAccessControl.data;
